const e=(e,n)=>{window.MentionMeFiredTags&&window.MentionMeFiredTags[e+n]&&(window.MentionMeFiredTags[e+n]=!1)};export{e as clearMentionMeFiredTag};
//# sourceMappingURL=clearMentionMeFiredTag.js.map
